// imports
import Carousel from 'minsky-kit/js/components/Carousel';

// class definition
export default class GalleryCarousel extends Carousel {
    // constructor
    constructor (args = {}, objectName = 'GalleryCarousel') {
        args.debug = args.debug || false;

        // super
        super(args, objectName);
    }

    // methods
    destroy () {
        // super destroy
        super.destroy();
    }

    // getters & setters
}

// Utils

// Event handlers
